/* eslint-disable prefer-destructuring */
/* eslint-disable react/self-closing-comp */
import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from '@reach/router';
import env from '@/env';
import { detectWebApp } from '@/utils';
// import logo192 from '@/assets/images/logo192.png';

interface HelmetHeadProps {
  title: string;
  description?: string;
  image?: string;
  entityName?: string;
}

const HelmetHead: React.FC<HelmetHeadProps> = ({ title, description, image, entityName }) => {
  const webApp = detectWebApp[env.siteId as keyof typeof detectWebApp];
  const coverImage = webApp.coverImage;
  const { pathname } = useLocation();

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <link rel="icon" href="/favicon.ico" />
      <link rel="canonical" href={`${env.rootUrl}${pathname}`} />

      <title>{title}</title>
      <meta name="description" content={description} />
      <meta
        name="keywords"
        content={`${webApp.siteName}, Open Banking, APIs, Open Banking APIs, Payment APIs, Lending APIs, KYC APIs, PSD2, CMA, AISP, PISP, Banking Regulations, GDPR, PSD2 Compliance, Africa, Asia, Oceania, Middle East, Europe, North America, South America`}
      />

      {/* <!-- Twitter Card data --> */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={webApp.metadata.site} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {/* <-- Twitter Summary card images must be at least 120x120px --> */}
      <meta
        name="twitter:image"
        content={image || `https://www.${webApp.domainName}${coverImage}`}
      />
      <meta property="fb:pages" content="101075744945572" />
      <meta property="fb:app_id" content={env.facebookID} />

      {/* <!-- Open Graph data --> */}
      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`${env.rootUrl}${pathname}`} />
      <meta
        property="og:image"
        content={image || `https://www.${webApp.domainName}${coverImage}`}
      />
      <meta
        property="og:image:secure"
        content={image || `https://www.${webApp.domainName}${coverImage}`}
      />
      <meta
        property="og:image:secure_url"
        content={image || `https://www.${webApp.domainName}${coverImage}`}
      />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="650" />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content={entityName || env.siteName} />

      {/* <script async src={`https://www.googletagmanager.com/gtag/js?id=${env.ga.trackingCode}`} /> */}
      {/* <script async nonce="AJbzXffZe9LYP0tc4a78">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${env.ga.trackingCode}');
        `}
      </script>
      <script
        nonce="AJbzXffZe9LYP0tc4a78"
        defer
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=b8cf16de-b634-4aa2-b2ca-3f11acaef139"
      />
      <script nonce="AJbzXffZe9LYP0tc4a78">
        {`
          gtag('event', 'conversion', {'send_to': '${env.ga.trackingCode}/2kAKCOOg4PUBEO7MqccB'});
        `}
      </script> */}
      {/* <script
        nonce="AJbzXffZe9LYP0tc4a78"
        id={webApp.gdpr.id}
        src={webApp.gdpr.src}
        data-cbid={webApp.gdpr.dataCbid}
        data-blockingmode="auto"
        type="text/javascript"
        async
      ></script> */}
    </Helmet>
  );
};

export default HelmetHead;
